@if (profile) {
  <aa-person-header
    [profile]="profile"
    [showTitle]="true"
    [units]="[profile.primaryUnitAffiliation]"
    [excludeInstitutionName]="true"
    [customUnitGroupingTitles]="customUnitGroupingTitles"
  ></aa-person-header>
  <aa-timeline
    [activities]="activities"
    [showCondensedActivities]="true"
    [lazyLoadScholars]="true"
    [maxScholarsToDisplay]="maxScholarsToDisplay"
    (showAllPeopleChange)="showPeople($event)"
    (showAllScholarsClick)="showAllCollaborators($event)"
  ></aa-timeline>
  @if (showViewProfileButton) {
    <button
      class="primary"
      [routerLink]="profile | personUrl"
      queryParamsHandling="merge"
    >
      View Profile
    </button>
  }
  <button (click)="closePopup()" class="close-popover">Close</button>
}
